import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {getUser} from "../actions/UserActions";

export class BasePage extends Component {

  componentDidMount() {
    getUser(this.props.dispatch);
  }

  render() {
    return <React.Fragment>
      {(!this.props.isLoggedIn) ? <Redirect to={"/login"}/> :
        <React.Fragment>
          {this.props.render()}
        </React.Fragment>
      }
    </React.Fragment>
  }
}

export default connect((state, props) => {
  return {
    isLoggedIn: state.user.isLoggedIn,
  }
})(BasePage);
